<!-- 底部组件 -->
<template>
  <div>
    <div :class="'foot type' + type">
      <div class="top">
        <div class="left">
          <div class="one" v-for="(item, index) in navs" v-if="$store.state.sizeType == 'pc' && item.children !== undefined" :key="index">
            <p class="title" @click="goPage(item)">{{ item.name }}</p>
            <div class="lists">
              <p @click="goPage(item2, index2)" v-for="(item2, index2) in item.children" :key="index2">{{ item2.name }}</p>
            </div>
          </div>

          <div class="one">
            <p class="title">{{ language.contactTitle }}</p>
            <div class="line">
              <img v-if="type == 2" class="icon" src="../assets/home/customer-service-line (1)2.png">
              <img v-else class="icon" src="../assets/home/customer-service-line (1).png">
              <div>{{ language.contactPhone }}</div>
            </div>
            <div class="line" v-for="(email, index) in language.emails" :key="index">
              <img v-if="index === 0 && type == 2" class="icon" src="../assets/home/mail-ai-line (2)2.png">
              <img v-else-if="index === 0" class="icon" src="../assets/home/mail-ai-line (2).png">
              <div v-else class="icon"></div>
              <div>{{ email }}</div>
            </div>
          </div>
          <div class="one" v-if="language.showFollow">
            <p class="title">{{ language.followTitle }}</p>
            <img class="erweima" src="../assets/home/erweima.png">
          </div>
        </div>
        <!-- <div class="logos" v-if="type == 2">
          <img class="logo1" src="../assets/home/wechat-fill (3).png">
          <img class="logo2" src="../assets/home/6kehul7hgry.png">
        </div>
        <div v-else>
          <img class="logo1" src="../assets/home/wechat-fill (2).png">
          <img class="logo2" src="../assets/home/dibuwithe.png">
        </div> -->
      </div>
      <div class="bottom" :class="{ combined: language.bottomCombined }">
        <span v-if="$store.state.sizeType == 'pc'">
          {{ language.copyright }}
          <template v-if="language.bottomCombined">
            <span class="button" @click="openModal(4)"> {{ language.privacyPolicy }}</span> |
            <span class="button" @click="openModal(3)">{{ language.legalNotice }}</span>
          </template>
        </span>
        <div v-else>
          <div v-for="(line, index) in language.copyrightMobile" :key="index">{{ line }}</div>
          <div v-if="language.bottomCombined">
            <span class="button" @click="openModal(4)">{{ language.privacyPolicy }}</span> |
            <span class="button" @click="openModal(3)">{{ language.legalNotice }}</span>
          </div>
        </div>
        <span v-if="!language.bottomCombined">
          <span class="button" @click="openModal(3)">{{ language.legalNotice }}</span> |
          <span class="button" @click="openModal(4)">{{ language.privacyPolicy }}</span>
        </span>
      </div>
    </div>
    <Modal
      v-model="open"
      :title="title"
      width="1200px"
      footer-hide>
      <div class="content">
        <div v-html="content"></div>
      </div>
  </Modal>
  </div>
  
</template>

<script>
export default {
  name: 'foot',
  inject: ['reload'],
  props: ["type"],
  data() {
    return {
      language: {
        emails: [],
        showFollow: true,
        bottomCombined: false,
        copyrightMobile: [],
      },
      navs: [],
      navs1: [],
      navs2: [],
      open: false,
      title: '',
      content: '',
    };
  },
  methods: {
    // 进入采购页面
    goCaigou: function () {
      window.open("http://b2b.rsm.com.cn:86/HomeSite/Site/Index");
    },
    // 进入其他页面
    goPage: function (item, index) {
      this.$router.push({ path: item.path, query: item.other ? { ...item.other } : {} });
    },
    openModal(type) {
      this.$config('/open/api/about/list', {type}).then(res => {
        this.content = res.data[0].content;
        if(type == 3){
          this.title = this.language.legalNotice;
        } else {
          this.title = this.language.privacyPolicy;
        }
        this.open = true
      })
    },
  },
  mounted() {
    this.navs = this.$language[this.$store.state.pageType].foot.navs;
    this.language = this.$language[this.$store.state.pageType].foot;
  }
};
</script>

<style scoped lang='scss'>
.foot {
  // height: 376px;
  padding: 0 calc(50% - 600px);
  background: #000024;
  color: #6B7285;
  font-size: 12px;
  font-weight: 300;
  // text-align: center;

  &.type2 {
    background: #F1F0F5;

    .title {
      color: #000 !important;
    }

    .line,
    p,
    .bottom {
      color: #333 !important;
    }
  }

  .top {
    // height: 335px;
    border-bottom: 1px solid #19194C;
    ;
    // display: flex;
    // justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 0.15rem;

    .left {
      width: 100%;
      display: flex;
      text-align: left;
      justify-content: space-between;

      .title {
        // font-family: Source Han Sans CN, Source Han Sans CN;
        font-size: 0.18rem;
        color: #FFFFFF;
        margin-bottom: 30px;
        font-weight: 400;
        cursor: pointer;
      }

      .line {
        display: flex;
        // font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 0.14rem;
        color: #FFFFFF;
        margin-bottom: 0.15rem;
        align-items: center;

        .icon {
          width: 0.24rem;
          height: 0.24rem;
          margin-right: 0.1rem;
        }
      }

      .lists {

        p {
          cursor: pointer;
          font-size: 0.14rem;
          margin-bottom: 15px;
          font-weight: 400;
          // font-family: Source Han Sans CN, Source Han Sans CN;
          color: #FFFFFF;
        }
      }
    }

    .logos {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.6rem;

      .logo1 {
        width: 0.43rem;
        height: 0.43rem;
      }

      .logo2 {
        width: 1.28rem;
        height: 0.3rem;
      }
    }
  }

  .bottom {
    height: 0.57rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;

    &.combined {
      justify-content: flex-start;
    }

    .button{
      cursor: pointer;

      &:hover{
        color: #2d8cf0;
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .foot {
    padding: 0 0.3rem;

    .top {
      padding-top: 0.3rem;

      .left {
        .title {
          font-size: 0.32rem;
          margin-bottom: 0.5rem;

        }

        .line {
          font-size: 0.32rem;

          .icon {
            width: 0.3rem;
            height: 0.3rem;
            margin-right: 0.2rem;
          }
        }

        .erweima {
          width: 1.12rem;
          height: 1.12rem;
        }
      }

      .logos {
        margin-top: 0.2rem;

        // .logo2{
        //   width: 2.11rem;
        //   height: 0.76rem;
        // }
      }
    }

    .bottom {
      height: 1.4rem;
      flex-direction: column;
      align-items: flex-start;
      font-size: 0.16rem;
      line-height: 0.32rem;
      justify-content: center;
    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/foot.vue